<template>
  <div class="about">
    <a-row class="about-head">
      <a-col :span="12">
        <p>关于我们</p>
      </a-col>
      <a-col :span="10"></a-col>
      <a-col :span="2">
        <a v-on:click="back">返回</a>
      </a-col>
    </a-row>
    <a-layout style="background-color: #576371;min-height: 90vh;">
      <a-layout-header class="about-title" style="background-color: #576371;">
        <h1>{{title}}</h1>
      </a-layout-header>
      <a-layout-content style="background-color: #576371;">
        <a-row class="about-con">
          <a-col :span="12">软件版本</a-col>
          <a-col :span="12" style=" text-align:right">{{ISElectron?versions.app+"-":""}}1.0.4</a-col>
        </a-row>
        <a-row class="about-con" v-if="ISElectron">
          <a-col :span="12">Electron</a-col>
          <a-col :span="12" style=" text-align:right">{{versions.electron}}</a-col>
        </a-row>
        <a-row class="about-con" v-if="ISElectron">
          <a-col :span="12">Chrome</a-col>
          <a-col :span="12" style=" text-align:right">{{versions.chrome}}</a-col>
        </a-row>
        <a-row class="about-con" v-if="ISElectron">
          <a-col :span="12">Node</a-col>
          <a-col :span="12" style=" text-align:right">{{versions.node}}</a-col>
        </a-row>
        <a-row class="about-con" v-if="ISElectron">
          <a-col :span="12">V8</a-col>
          <a-col :span="12" style=" text-align:right">{{versions.v8}}</a-col>
        </a-row>
        <a-row class="about-con" v-if="ISElectron">
          <a-col :span="12" @click="CheckUpdates()">检查更新</a-col>
          <a-col
            :span="12"
            style=" text-align:right"
            @click="DownloadUpdates()"
            v-html="CheckUpdatesmag"
          ></a-col>
        </a-row>
      </a-layout-content>
      <a-layout-footer class="about-footer" style="background-color: #576371;">
        <div>
          <img src="../assets/images/about_logo.png" alt width="200" />
        </div>
        <p>深圳市荣盛智能装备有限公司</p>
      </a-layout-footer>
    </a-layout>
    <a-modal
      v-model="visible"
      title="SAS更新程序"
      centered
      cancelText="稍后更新"
      okText="立即更新"
      @cancel="UpdatesCancel"
      :closable="false"
      @ok="UpdatesOK"
      :width="300"
      :maskClosable="false"
      :cancel-button-props="{ props: { disabled: ISUpdates } }"
      :ok-button-props="{ props: { disabled: ISUpdates } }"
    >
      <div style="text-align: center;">
        <a-progress type="circle" :percent="percent" style="margin: 0px 66px;" />
        <p v-if="ISUpdates">{{Updatesmag}}</p>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import SetupService from "../api/SetupService";
export default {
  components: {},
  data() {
    return {
      title: "SAS应急单兵作战系统",
      LoreVersion: "",
      Updatestimer: null,
      GetLoreVersiontimer: null,
      versions: null,
      ISElectron: false,
      LatestVersion: "0.0.1",
      CheckUpdatesmag: "",
      visible: false,
      ISUpdates: false,
      Updatesmag: "正在下载中,下去完成后会自动重启应用",
      percent: 0
    };
  },
  computed: {
    Config() {
      return this.$store.state.Config;
    }
  },
  mounted() { 
    
  },
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    }, 
    DownloadUpdates() {
      if (this.ISElectron && this.LatestVersion != this.versions.app) {
        this.visible = true;
      }
    },
    UpdatesCancel() {
      if (!this.ISUpdates) {
        this.visible = false;
      }
    },
    UpdatesOK() {
      if (this.ISElectron && this.LatestVersion != this.versions.app) {
        this.ISUpdates = true;
        ipc.updater();
        this.Updatestimer = setInterval(() => {
          this.getprogress();
        }, 100);
      }
    },
    getprogress() {
      let state = ipc.getprogress();
      console.info(state);
      if (state && state.percent) {
        this.percent = (state.percent * 100).toFixed(2);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.Updatestimer);
  }
};
</script>
<style  lang="less" scoped>
.about-head {
  font-size: 36px;
  color: #fff;
  background-color: #1f2730;
}
.about-head p {
  margin: -5px 0 0 15px;
  //border-left: 5px solid #3fdb23;
  padding: 0 0 0 15px;
}
.about-head p::before {
  font-size: 40px;
  content: "|";
  color: #3fdb23;
  font-weight: bold;
  margin-right: 15px;
}
.about-head a {
  color: #ccc;
}
.about-title {
  color: #fff;
  text-align: center;
  margin: 30px;
}
.about-title h1 {
  color: #fff;
  font-weight: bold;
  font-size: 36px;
}
.about-con {
  padding: 10px 40px 10px 40px;
  background: #778899;
  color: #fff;
  font-size: 20px;
  border-bottom: 1px solid #576371;
}
.about-footer{
   text-align: center;
    color: #fff;
  font-size: 24px;
}
.about-rear {
  position: absolute;
  bottom: 40px;
  width: 92%;
  text-align: center;
}
.about-rear div {
  margin-bottom: 12px;
}
.about-rear p {
  color: #fff;
  font-size: 24px;
}
</style>
